module.exports = __webpack_public_path__ + "static/img/good_morning_logo.2d9e480.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/common/recruit_2021/program_logo/good_morning_logo.png
// module id = P8bR
// module chunks = 0